import React from 'react'
import { connect } from 'react-redux'

import Details from 'components/LoanDetails'
import Highlight from './Highlight'
import FinancialBreakdown from './FinancialBreakdown'
import Checkbox from '../../commons/Checkbox'

import ActionButtons from '../../commons/ActionButtons'
import ErrorMessageCard from '../../commons/ErrorMessageCard'

import {
  updateLoanSummaryStart
} from './../../../actions'

class LoanSummary extends React.Component {
  state = {
    loanSummaryReviewed: this.props.loanSummaryReviewed || false,
    continueButtonEnabled: true
  }

  componentDidMount() {
    window.scrollTo({top: 0})
  }

  onContinueClick = () => {
    this.setState({ continueButtonEnabled: false })

    let { loanSummaryReviewed } = this.state
    if (this.props.role === 'primary') {
      loanSummaryReviewed = true
    }

    this.props.updateLoanSummaryStart({
      loanSummaryReviewed: loanSummaryReviewed
    })
  }

  continueEnabled() {
    const { role, canViewLoanSummary } = this.props
    if (role === 'primary') {
      return true
    }

    if (role !== 'primary' && !canViewLoanSummary) {
      return true
    } else if (role !== 'primary' && canViewLoanSummary && this.state.loanSummaryReviewed) {
      return true
    } else {
      return false
    }
  }

  render() {
    const {
      loanDetail,
      loanApplication,
      canViewLoanSummary,
      needFinancialGraph,
      primaryApplicantName,
    } = this.props

    const { continueButtonEnabled } = this.state

    return(
      <div>
        <h3 className='mb-3'>Here is your loan</h3>

        <div className='card card-single'>
          <div className='card-header'>Details</div>
          {
            canViewLoanSummary ? (
              <div className='card-body'>
                <Highlight
                  loanApplication={ loanApplication }
                  loanDetail={ loanDetail }
                />
                <Details
                  loanDetail={ loanDetail }
                  loanApplication={ loanApplication }
                  canViewLoanSummary={ canViewLoanSummary }
                />
              </div>
            ) : (
              <div className='card-body'>
                <ErrorMessageCard title='Loan setup is currently in progress'>
                  <p>
                    It seems like {primaryApplicantName} is still working on setting up the loan for your joint application.
                  </p>
                  <p>
                    You can proceed with the rest of your application but you need to come back and review the loan setup once {primaryApplicantName} is done before you can submit the application.
                  </p>
                </ErrorMessageCard>
              </div>
            )
          }
        </div>
        {
          (canViewLoanSummary && needFinancialGraph) &&
          <FinancialBreakdown
            loanDetail={ loanDetail }
          />
        }
        {
          (canViewLoanSummary && this.props.role === 'secondary') &&
            <div>
              <Checkbox
                checked={ this.state.loanSummaryReviewed }
                onClick={ (e) => this.setState({loanSummaryReviewed: e.currentTarget.checked})}
                id='loan-summary-reviewed'
                text="I have reviewed the loan details"
              />
              <br/>
            </div>
        }
        <ActionButtons
          continueEnabled={ this.continueEnabled() && continueButtonEnabled }
          onContinueClick={ this.onContinueClick }
          onGoBackClick={ this.props.onGoBackClick }
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  loanDetail: state.loanDetail,
  role: state.loanApplicationUser.primary.role,
  loanSummaryReviewed: state.loanApplicationUser.primary.loanSummaryReviewed,
  canViewLoanSummary: state.loanApplicationUser.primary.canViewLoanSummary,
  needFinancialGraph: state.loanApplication.needFinancialGraph,
  primaryApplicantName: state.loanApplication.primaryApplicantName,
  loanApplication: state.loanApplication,
})

export default connect(mapStateToProps, {
  updateLoanSummaryStart,
})(LoanSummary)
